// Import the functions you need from the SDKs you need
/* import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics"; */
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyApeljgdOjZ651k8a-1ppCWNImHYvcjrmk",
  authDomain: "onemusic-f0b73.firebaseapp.com",
  projectId: "onemusic-f0b73",
  storageBucket: "gs://onemusic-f0b73.appspot.com",
  messagingSenderId: "583930565232",
  appId: "1:583930565232:web:7acd0f9503943214761ab5",
  measurementId: "G-FYLV9F3N27"
};

// Initialize Firebase
export default firebaseConfig